import { forwardRef } from 'react'

const ResponsiveSVGWrapper = forwardRef((props, ref) => (
  <div
    key="svg-wrapper"
    ref={ref}
    css={{
      position: 'relative',
      verticalAlign: 'top',
      overflow: 'hidden',
      width: '100%'
    }}
    {...props}
  />
))

export default ResponsiveSVGWrapper
